var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-badge",class:_vm.badgeClass},[_c('icon-status',{attrs:{"icon-status":_vm.status}}),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.status)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }